import { IClaim } from '../models/claim'
import { BaseUrl } from './base_url_enum'
import Api from './index'
import { IApiResponse } from './index'

export const getClaims = (relationNumber: number) => Api<IApiResponse<IClaim[]>>('GET', `v2/relations/${relationNumber}/claims`, BaseUrl.Claim)

export const getClaim = (relationNumber: number, claimHash: string) =>
  Api<IApiResponse<IClaim>>('GET', `v2/relations/${relationNumber}/claims/${claimHash}`, BaseUrl.Claim, undefined, true)

export const deleteClaimConcept = (relationNumber: number, temporaryClaimReference: string) =>
  Api<IApiResponse<IClaim>>('DELETE', `v2/relations/${relationNumber}/claims/${temporaryClaimReference}`, BaseUrl.Claim)

export const createClaimConcept = (
  claim: Pick<
    IClaim,
    'agentNumber' | 'policyNumber' | 'relationNumber' | 'branche'
  >
) =>
  Api<IApiResponse<IClaim>>(
    'POST',
    `v2/relations/${claim.relationNumber}/claims`,
    BaseUrl.Claim,
    {
      ...claim
    }
  )

export const storeClaim = (
  claim: Pick<
    IClaim,
    'id' | 'policyNumber' | 'dateOfLoss' | 'text' | 'phoneNumber' | 'relationNumber'
  >
) =>
  Api<IApiResponse<IClaim>>(
    'POST',
    `v2/relations/${claim.relationNumber}/claims/${claim.id}`,
    BaseUrl.Claim,
    {
      ...claim,
      telephoneNumber: claim.phoneNumber
    }
  )

export const updateClaimConcept = (claim: IClaim) =>
  Api<IApiResponse<IClaim>>(
    'PUT',
    `v2/relations/${claim.relationNumber}/claims/${claim.id}`,
    BaseUrl.Claim,
    {
      ...claim,
      telephoneNumber: claim.phoneNumber
    }
  )

export const uploadAdditionalClaimAttachment = async (relationNumber: number, id: string, base64: string, fileName: string) =>
  Api<IApiResponse<IClaim>>(
    'POST',
    `v2/relations/${relationNumber}/claims/${id}/upload`,
    BaseUrl.Claim,
    {
      file: base64,
      name: fileName
    }
  )

export const removeAdditionalClaimAttachment = async (fileUrl: string) =>
  Api<IApiResponse<IClaim>>('DELETE', fileUrl, BaseUrl.File)

export const getDASLink = (relationNumber: number, policyNumber: string) =>
  Api<{ url: string, decrypted: string }>(
    'GET',
    `v2/relations/${relationNumber}/policy/${policyNumber}/das-link`,
    BaseUrl.Claim
  )
